"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
const tld_list_json_1 = __importDefault(require("../tld-list.json"));
const TLD = tld_list_json_1.default.map((data) => data.Name).join("|");
// eslint-disable-next-line security/detect-non-literal-regexp
exports.domainRegExp = new RegExp(`^[a-z0-9-_]+\.(${TLD})$`, "i");
//# sourceMappingURL=domain-reg-exp.js.map